import { getTranslationFallback } from '../../utils/translation.utils';
import ProductFilterBase from './product-filter-base.model';
import { IProductFilterDTO, ProductFilterTypes } from './product-filter-base.model';

export interface IProductFilterMultiSelectOption {
  count: number;
  disabled: boolean;
  name: string;
  value: string;
}

export default class ProductFilterMultiSelect extends ProductFilterBase {
  options: IProductFilterMultiSelectOption[] = [];
  type = ProductFilterTypes.MultiSelect;

  static create(data: IProductFilterDTO): ProductFilterMultiSelect {
    return Object.assign(new ProductFilterMultiSelect(), data, {
      name: getTranslationFallback(`dcp.search.facet.${data.code}`, data.displayName ?? data.name),
      value: data.values.filter((value) => value.selected).map((value) => value.code),
      visible: data.visible,
      options: data.values.map((value) => ({
        count: value.count,
        disabled: value.count === 0,
        name: getTranslationFallback(`dcp.search.facet.${value.code}`, value.name as string) || '',
        value: value.code,
      })),
    });
  }

  clone(): ProductFilterMultiSelect {
    return ProductFilterMultiSelect.create(this);
  }

  isSelected(): boolean {
    return this.value.length > 0;
  }

  getResetValue(): any[] {
    return [];
  }

  getQueryValue(): string {
    let queryValue = '';

    this.value.forEach((value: string) => {
      // Temporary double encode colon
      // see https://jira.mercedes-benz.io/browse/EMHRO-1153
      value = value.replace(':', encodeURIComponent(':'));
      queryValue += `:${this.code}:${value}`;
    });

    return queryValue;
  }
}
